var login = {
  translation: {
    common: {
      accept: 'Akceptuje',
      alreadyUser: 'Masz konto?',
      and: 'i',
      backToLogin: 'Powrót do logowania',
      continueWith: 'Kontynuuj z {{provider}}',
      createAccount: 'Utwórz konto',
      createYourAccount: 'Utwórz konto',
      emailOrUsername: 'Email lub nazwa użytkownika',
      login: 'Logowanie',
      logIn: 'Zaloguj',
      logInToBoards: 'Logowanie',
      newToBoards: 'Nowy użytkownik?',
      pageNotFound_title: 'Nie znaleziono strony',
      password: 'Hasło',
      privacyPolicy: 'Politykę prywatności',
      register: 'Rejestracja',
      registerWithGoogle: 'Zarejestruj przez Google',
      termsOfService: 'Warunki świadczenia usług',
      togglePasswordVisibility: 'Pokaż/Ukryj hasło',
    },
  },
};

export { login as default };
